import React from 'react';
import { Modal, Button } from 'antd';
import s from './s.module.less';
import { IMedication } from 'types/operation';

interface IDeleteMedicationModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    specialtyName?: string;
    medication?: IMedication;
    loading?: boolean;
}

const DeleteMedicationModal = ({
    open,
    onCancel,
    onConfirm,
    specialtyName,
    medication,
    loading,
}: IDeleteMedicationModalProps) => {
    return (
        <Modal
            title={`Remove this medication from ${specialtyName}?`}
            open={open}
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    danger
                    loading={loading}
                    onClick={onConfirm}
                >
                    Remove
                </Button>,
            ]}
        >
            <p className={s.content}>
                Please note that <strong>{medication?.title}</strong> will be immediately
                removed from the <strong>{specialtyName}</strong> on the HelloKlarity
                website. Are you sure you want to proceed?
            </p>
        </Modal>
    );
};

export default DeleteMedicationModal;
